import React from 'react';
import PropTypes from 'prop-types';

import HubModel from 'models/hub';

import FeaturedDestination from 'components/hub/featured-destination';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
};

const FeaturedDestinations = ({ hub }) => {
  const featuredDestinations = hub.featuredDestinations;
  if (!featuredDestinations) { return null; }
  const destinationsList = featuredDestinations.valueSeq().map(destination => (
    <FeaturedDestination destination={destination} key={destination.uuid} />
  ));

  return (
    <div className="row featured-destinations-wrapper">
      { destinationsList }
    </div>
  );
};


FeaturedDestinations.propTypes = propTypes;

export default FeaturedDestinations;
